import React, { useEffect, useState } from "react";
import EditDocsModalPresenter from "./EditDocsModalPresenter";
import DTOEditDocsModal from "./DTOEditDocsModal";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { documentService } from "../../../../api/services/documentService";
import { toast } from "react-hot-toast";
import {
  setEmployeeActiveDocs,
  setEmployeeActiveDocsLoader,
} from "../../../../infra/aggregates/myProfile/DocumentAggregates/getActiveEmpDocsSlice";
import {
  setEmployeeExpiredDocs,
  setEmployeeExpiredDocsLoader,
} from "../../../../infra/aggregates/myProfile/DocumentAggregates/getExpiredEmpDocsSlice";
import _ from "lodash";
import { useTranslation } from "react-i18next";
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  IndividualDocuments: any;
  trans?: any;
}
const EditDocsModalController = ({
  isModalOpen,
  closeModal,
  IndividualDocuments,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const { i18n } = useTranslation();
  const [EmpDocTypes, setEmpDocTypes] = useState<[]>([]);
  const [countries, setCountries] = useState<[]>([]);
  const store_ActiveDocuments: any = useAppSelector(
    (state) => state.getActiveEmpDocsSlice.empDocsData
  );
  const store_ExpiredDocuments: any = useAppSelector(
    (state) => state.getExpiredEmpDocsSlice.empExpDocsData
  );
  const patchdata = (data: any) => {
    updateEmpDocs(data);
  };
  const dispatch = useAppDispatch();
  async function updateEmpDocs(data: any) {
    let isFormValid = true;

    if(!selector || !data.documentTypeId || !data.countryName)
    {
      isFormValid = false;
    }

    if (isFormValid) {
      const empId: any = selector.emp_id;
      const CompanyID: any = selector.company_id;
      // const companyID: any = selector.company_id;

      const formData: any = new FormData();
      formData.append("id", data.docId);
      formData.append("empId", empId);
      formData.append("CompanyID", CompanyID);
      formData.append("document_type_id", data.documentTypeId);
      formData.append("issue_country", data.countryName);
      formData.append("issue_date", data.issueDate);
      if(!data?.showExpiryDate) {
        formData.append("validity_date", data.expiredDate);
      }
      formData.append("identifier_number", data.identifierNo);
      formData.append("remarks", data.remarks);
      if (data?.newattachement) {
        formData.append("document[]", data.file);
      }
      
      formData.append("full_path", "true");
      formData.append("removed", data?.removed);
      formData.append("locale", localStorage.getItem("emplang"));
      if (data?.showReferenceNo) {
        formData.append('reference_number', data?.referenceNo);
      }

      if (data?.showAddReferenceNo) {
        formData.append('additional_reference_number', data?.addReferenceNo);
      }


      const response: any = await documentService.updateEmpDocs(formData);

      if (response.response == "success") {
        if (i18n.language == "ar") {
          refreshData();
        } else {
          if (response?.data[0]?.expired == true) {
            const tempExpiredDocs = [...store_ExpiredDocuments];

            const expired: any = _.filter(tempExpiredDocs, (data: any) => {
              return data.id !== response?.data[0]?.id;
            });

            expired.push(response?.data[0]);
            dispatch(setEmployeeExpiredDocs(expired));

            const tempActiveDocs = [...store_ActiveDocuments];
            const active: any = _.filter(tempActiveDocs, (data: any) => {
              return data.id != response?.data[0]?.id;
            });
            dispatch(setEmployeeActiveDocs(active));
          } else if (!response?.data[0]?.expired) {
            const tempActiveDocs = [...store_ActiveDocuments];

            const active: any = _.filter(tempActiveDocs, (data: any) => {
              return data.id != response?.data[0]?.id;
            });
            active.push(response?.data[0]);
            dispatch(setEmployeeActiveDocs(active));
          }

          toast.success(trans("Updated Successfully"));
        }
      }
      closeModal();
    }
    else
    {
      toast.error(trans("Please fill the missing fields!"));
    }
  }

  const refreshData = async () => {
    dispatch(setEmployeeExpiredDocsLoader(true));
    const response: any = await documentService.getExpiredDocs(
      selector.company_id,
      selector.emp_id
    );

    if (response.response == "success") {
      const empExpDocsData: any = response?.data;

      dispatch(setEmployeeExpiredDocs(empExpDocsData));
      /* Passing Props to Controller */

      dispatch(setEmployeeExpiredDocsLoader(false));
    } else {
      dispatch(setEmployeeExpiredDocsLoader(false));
      return;
    }
    dispatch(setEmployeeActiveDocsLoader(true));
    const resp: any = await documentService.getActiveDocs(
      selector.company_id,
      selector.emp_id
    );

    if (resp.response == "success") {
      const empDocsData: any = resp?.data;

      dispatch(setEmployeeActiveDocs(empDocsData));
      /* Passing Props to Controller */

      dispatch(setEmployeeActiveDocsLoader(false));
    } else {
      dispatch(setEmployeeActiveDocsLoader(false));
      return;
    }
  };
  async function callBack(data: []) {
    setCountries(data);
  }
  async function callBackEmptypes(data: []) {
    setEmpDocTypes(data);
  }
  return (
    <>
      <div>
        <DTOEditDocsModal
          setAllCountries={callBack}
          setAllEmpDocsType={callBackEmptypes}
        />
        <EditDocsModalPresenter
          callBackData={patchdata}
          IndividualDocuments={IndividualDocuments}
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          allEmpDocTypes={EmpDocTypes}
          allCountires={countries}
          trans={trans}
        />
      </div>
    </>
  );
};
export default EditDocsModalController;
